import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { BookOpen, Download } from "lucide-react";

export default function PolicyLibrary() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/policies").then((r) => setItems(r.data)).catch(() => {}); }, []);

    return (
        <div className="space-y-6" data-testid="policies-page">
            <div>
                <h1 className="font-heading text-3xl font-extrabold text-nhs-ink">Policy Library</h1>
                <p className="text-slate-500 mt-1">Trust policies grounding all advice and case handling.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
                {items.map((p) => (
                    <div key={p.id} className="bg-white rounded-lg border border-slate-200 shadow-sm p-6 flex flex-col" data-testid={`policy-${p.id}`}>
                        <div className="flex items-center justify-between">
                            <div className="h-10 w-10 rounded-lg bg-nhs-blue/10 flex items-center justify-center"><BookOpen className="h-5 w-5 text-nhs-blue" /></div>
                            <Badge className="bg-slate-100 text-slate-600 border-0">{p.category}</Badge>
                        </div>
                        <h3 className="font-heading font-semibold text-lg text-nhs-ink mt-4">{p.title}</h3>
                        <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{p.summary}</p>
                        <Button variant="outline" className="mt-4 self-start border-slate-300 gap-2" data-testid={`download-${p.id}`}><Download className="h-4 w-4" /> Download</Button>
                    </div>
                ))}
            </div>
        </div>
    );
}
